import React, { useState, useEffect } from 'react';
import constants from '../../../constants/constants';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { useRef } from 'react';
import back from "../../../images/back.svg";
import { Controller, useForm } from "react-hook-form";
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import classNames from 'classnames';
import { Dropdown } from 'primereact/dropdown';
import ProjectTaskHeader from './ProjectTaskHeader';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { RadioButton } from 'primereact/radiobutton';
import { InputTextarea } from 'primereact/inputtextarea';
import { ProgressBar } from 'primereact/progressbar';
import pencil from '../../../images/projects/Pencil.svg';
import trash from '../../../images/projects/Trash.svg';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import axiosInstance from '../../../constants/axiosInstance';
import { useStoreState, useStoreActions} from 'easy-peasy';

const ProjectsDefinition = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [subTaskList, setSubTaskList] = useState();
    const [userList, setUserList] = useState();
    const [departmentList, setDepartmentList] = useState();
    const [records, setRecords] = useState();
    const [tochild, setTochild] = useState(null);
    const [tochildSubTask, setTochildSubTask] = useState(null);
    const [subTaskEdit, setSubTaskEdit] = useState(null);
    const [viewScreen, setViewScreen] = useState(false);
    const [taskScreen, setTaskScreen] = useState(false);
    const [taskView, setTaskView] = useState(false);
    const toast = useRef(null);
    const setFilterProjects = useStoreActions((actions) => actions.projectModel.setFilterProjects);
    const subTaskProjectName = useStoreState((actions) => actions.projectModel.subTaskProjectName);
    const setSubTaskProjectName = useStoreActions((actions) => actions.projectModel.setSubTaskProjectName);
    const subTaskRedirect = useStoreState((actions) => actions.projectModel.subTaskRedirect);
    const setSubTaskRedirect = useStoreActions((actions) => actions.projectModel.setSubTaskRedirect)
    const fromDashboard = useStoreState((actions) => actions.projectModel.fromDashboard);
    const setFromDashboard = useStoreActions((actions) => actions.projectModel.setFromDashboard);
    

    useEffect(() => {
        getProjectTaskHeader();
        getUserList();
        getDepartmentList();
        setFilterProjects(null);
        setSubTaskProjectName(null); 
        setSubTaskRedirect(null);
        setFromDashboard(null);
    }, []);

    const getProjectTaskHeader = () => {
        setIsLoading(true);
        axiosInstance
            .get(constants.APQP_UPL.TASK_HEADER)
            .then((resp) => {
                setRecords(resp?.data?.data);
            })
            .catch((e) => console.error(e))
            .finally(() => {
                setIsLoading(false);
            });
    }

    const getSubTask = (data) => {
        setIsLoading(true);
        axiosInstance
            .get(constants.APQP_UPL.TASK_HEADER + "/" + data?._id)
            .then((resp) => {
                setSubTaskList(resp?.data?.data[0]?.subTasks);
            })
            .catch((e) => console.error(e))
            .finally(() => {
                setIsLoading(false);
            });
    }

    const getUserList = () => {
        setIsLoading(true);
        axiosInstance
            .get(constants.URL.USERS + "?page=1&limit=1000&sort_by=-created_at")
            .then((resp) => {
                setUserList(resp?.data?.data);
            })
            .catch((e) => console.error(e))
            .finally(() => {
                setIsLoading(false);
            });
    }

    const getDepartmentList = () => {
        setIsLoading(true);
        axiosInstance
            .get(constants.URL.METADATA_DEPARTMENT)
            .then((resp) => {
                setDepartmentList(resp?.data?.[0]?.department);
            })
            .catch((e) => console.error(e))
            .finally(() => {
                setIsLoading(false);
            });
    }

    const defaultValues = { subTaskName: "", subTaskDescription: "", assignTo: "", fileAttachment: "", subTaskDepartment: "", taskCriticality:""};
    const form = useForm({ defaultValues });
    const { reset, setValue } = form;
    const errors = form.formState.errors;
    const getFormErrorMessage = (name) => {
        return errors[name] ? <small className="p-error">{errors[name].message}</small> : <small className="p-error">&nbsp;</small>;
    };
    
    useEffect(() => {
        if (subTaskEdit) {
            setValue("subTaskName", subTaskEdit?.subTaskName)
            setValue("subTaskDescription", subTaskEdit?._id?.subTaskDescription)
            setValue("subTaskDepartment", subTaskEdit?._id?.subTaskDepartment)
            setValue("assignTo", subTaskEdit?._id?.assignTo?._id)
            setValue("fileAttachment", subTaskEdit?._id?.fileAttachment === true ? "Yes" : "No")
            setValue("taskCriticality", subTaskEdit?._id?.subTaskCriticality)
            setValue("actionPlan", subTaskEdit?._id?.subTaskActionPlan)
            // setSelectedTaskCriticality(subTaskEdit.subTaskCriticality);
            setSelectedActionPlan(subTaskEdit.subTaskActionPlan);
        }
    }, [subTaskEdit]);

    const onSubmitTask = (data) => {
        const payload = {
            subTaskName: data.subTaskName,
            subTaskDescription: data.subTaskDescription,
            subTaskDepartment: data.subTaskDepartment, 
            assignTo: data.assignTo,
            fileAttachment: data.fileAttachment === "Yes" ? true : false,
            taskHeader_id: tochildSubTask?._id, //"pjt_01hjnhmmf5fjprsz3zpf25m2kf",
            subTaskCriticality: data.taskCriticality,
            subTaskActionPlan: data.actionPlan,
        }
        setIsLoading(true);
        if (subTaskEdit) {
            axiosInstance.patch(constants.APQP_UPL.SUB_TASKS + "/" + subTaskEdit?._id?._id, payload)
                .then((resp) => {
                    // console.log(resp?.data?.data);
                    getProjectTaskHeader();
                    toast.current.show({ severity: "success", summary: "Success", detail: "Updated Successfully" });
                    reset();
                    getSubTask(tochildSubTask);
                    setSubTaskEdit(null);
                }).catch((e) => {
                    toast.current.show({ severity: "error", summary: "Failure", detail: e?.response?.data?.message });
                    console.error(e);
                }).finally(() => {
                    setIsLoading(false);
                })
        } else {
            axiosInstance.post(constants.APQP_UPL.SUB_TASKS, payload)
                .then((resp) => {
                    // console.log(resp?.data?.data);
                    getProjectTaskHeader();
                    toast.current.show({ severity: "success", summary: "Success", detail: "Added Successfully" });
                    reset();
                    getSubTask(tochildSubTask);
                }).catch((e) => {
                    toast.current.show({ severity: "error", summary: "Failure", detail: e?.response?.data?.message });
                    console.error(e);
                }).finally(() => {
                    setIsLoading(false);
                })
        }
    }

    const reject = () => {
        toast.current.show({ severity: 'warn', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
    }

    const handleTaskDelete = (data) => {
        setIsLoading(true);
        axiosInstance.delete(constants.APQP_UPL.TASK_HEADER + "/" + data?._id)
            .then((resp) => {
                getProjectTaskHeader();
                toast.current.show({ severity: "success", summary: "Confirmed", detail: "Deleted Successfully", life: 3000 });
            }).catch((e) => {
                toast.current.show({ severity: "error", summary: "Failure", detail: e?.response?.data?.message });
                console.error(e);
            }).finally(() => {
                setIsLoading(false);
            })
    }

    const confirm = (item) => {
        confirmDialog({
            message: 'Do you want to delete this record?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            defaultFocus: 'reject',
            acceptClassName: 'p-button-danger',
            accept: () => handleTaskDelete(item),
            reject,
            acceptClassName: "btn-black",
            rejectClassName: "btn-black",
            draggable: false,
            // className: "confirm_dilog",
        });
    };

    const handleSubTaskDelete = (data) => {
        setIsLoading(true);
        axiosInstance.delete(constants.APQP_UPL.SUB_TASKS + "/" + data?._id?._id)
            .then((resp) => {
                getSubTask(tochildSubTask);
                toast.current.show({ severity: "success", summary: "Confirmed", detail: "Deleted Successfully", life: 3000 });
            }).catch((e) => {
                toast.current.show({ severity: "error", summary: "Failure", detail: e?.response?.data?.message });
                console.error(e);
            }).finally(() => {
                setIsLoading(false);
            })
    }
    
    const confirmSubTask = (item) => {
        confirmDialog({
            message: 'Do you want to delete this Sub Task?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            defaultFocus: 'reject',
            acceptClassName: 'p-button-danger',
            accept: () => handleSubTaskDelete(item),
            reject,
            acceptClassName: "btn-black",
            rejectClassName: "btn-black",
            draggable: false,
            // className: "confirm_dilog",
        });
    };


    const onPositionChange = (id, newPosition) => {
        const payload = {
            _id: id,
            newPosition: newPosition,
        }
        setIsLoading(true);
            axiosInstance.patch(constants.APQP_UPL.UPDATE_TASK_POSITION, payload)
                .then((resp) => {
                    // toast.current.show({ severity: "success", summary: "Success", detail: "Updated Successfully" });
                }).catch((e) => {
                    // toast.current.show({ severity: "error", summary: "Failure", detail: e?.response?.data?.message });
                    console.error(e);
                }).finally(() => {
                    setIsLoading(false);
                })
        }

    const header = (
        <div className="head-1">
             {subTaskEdit ?
            <h2 className="head-2">Update Sub Task</h2>
             : <h2 className="head-2">Add Sub Task</h2>
            }
        </div>
    );

    const customButtonTemplate = (item) => {
        return (
            <div className='flex justify-content-end gap-2'>
                <div><Button className="btn-black mx-2" label="Sub Task" icon="pi pi-plus" onClick={() => { setTaskScreen(true); getSubTask(item); setTochildSubTask(item); setSubTaskEdit(null); reset(); }} /></div>
                <div className='mx-2 text-center align-items-center justify-content-center flex'>< img src={pencil} onClick={() => { setViewScreen(true); setTochild(item) }} style={{ cursor: 'pointer' }}/></div>
                <div className='mx-2 text-center align-items-center justify-content-center flex'>< img src={trash} onClick={() => confirm(item)} style={{ cursor: 'pointer' }}/></div>
            </div>
        );
    };

    const customSubTaskButtonTemplate = (item) => {
        return (
            <div className='flex justify-content-end gap-2'>
                <div className='mx-2'>< img src={pencil} onClick={() => setSubTaskEdit(item)} style={{ cursor: 'pointer' }}/></div>
                <div className='mx-2'>< img src={trash} onClick={() => confirmSubTask(item)} style={{ cursor: 'pointer' }}/></div>
            </div>
        );
    };

    const renderButtonGroup = () => (
        <span>
            <Button size="small" label="Clear" className="btn-clear mx-2" onClick={() => { reset(defaultValues, { keepErrors: false }); }} />
        </span>
    )

    const renderUpdateSave = () => (
        <div onClick={form.handleSubmit(onSubmitTask)}>
        {subTaskEdit ?
            <Button icon="pi pi-check" size="small" loading={isLoading} label="Update" className="btn-yellow" />
            : <Button icon="pi pi-check" size="small" loading={isLoading} label="Save" className="btn-yellow" />
        }
        </div>
    )

    const handleChildData = (updatedData) => {
     setTaskScreen(false);
     setViewScreen(false);
     getProjectTaskHeader();
     setTochild(null);
   };

    const taskCriticalityOptions = [
        { label: "No", value: "Rejected" },
        { label: "With derogation", value: "Acceptedwithderogation" },
        { label: "Yes", value: "Accepted" }
      ];
      const actionPlan = [
        { label: "Checked", value: "Checked" },
        { label: "Not Checked", value: "notChecked" }
      ];
    const [selectedTaskCriticality, setSelectedTaskCriticality] = useState("");
    const [selectedActionPlan, setSelectedActionPlan] = useState("");


    return (
        <div>
            <Toast ref={toast} />
            <ConfirmDialog />
            {!viewScreen && !taskScreen ?
                <div>
                    <div className="title1 mt-2">
                        <div className="PS-title pt-2">Task Register</div>
                        <div className="btn2">
                            <div>
                                <Button className="btn-black mr-2" label="Task" icon="pi pi-plus" onClick={() => setViewScreen(true)} /></div>
                        </div>
                    </div>
                    {isLoading ? 
            <ProgressBar mode="indeterminate" style={{ height: '2px' }} className='my-3'></ProgressBar> : 
            <hr className='hr-line'></hr>}
                    <div className="mt-4">
                    <DataTable tableStyle={{ minWidth: '50rem' }} reorderableColumns reorderableRows onRowReorder={(e) => {setRecords(e.value); const movedId = e.value[e.dropIndex]._id;  const newPosition = e.dropIndex + 1; onPositionChange(movedId, newPosition);}}  value={records}>
                           <Column rowReorder style={{ width: '3rem' }} />
                            <Column field="headerTitle" header="Title" className='col-4 user-project-header' bodyClassName="user-project-bodyColumn"></Column>
                            <Column field= "subTaskCount" header="Sub Tasks" className='col-4 user-project-header' bodyClassName="user-project-bodyColumn"></Column>
                            <Column field="" header="" body={(rowData) => (customButtonTemplate(rowData))} className='col-4'></Column>
                        </DataTable>
                        {/* {records && records?.length === 0 ? "No Data found" : null} */}
                    </div>
                </div>
                : (viewScreen && !taskScreen) ?
                    <div>
                        <div className="title1 cursor-pointer mt-2" onClick={() => {setViewScreen(false); getProjectTaskHeader(); setTochild(null)}}>
                            <img src={back} className="back-logo mr-2" />
                            <span className="PS-title pt-2">Task Register / Add Task Definition</span>
                        </div>
                        <hr className="hr-line"></hr>
                        <ProjectTaskHeader tochild={tochild} sendDataToParent={handleChildData} />
                    </div>
                    : taskScreen && !taskView ?
                        <div>
                            <div className="title1 cursor-pointer mt-2" onClick={() => { setViewScreen(false); setTaskScreen(false); setTaskView(false); getProjectTaskHeader(); }}>
                                <img src={back} className="back-logo mr-2" />
                                <span className="PS-title pt-2">Task Register / {tochildSubTask?.headerTitle}</span>
                            </div>
                            <hr className="hr-line"></hr>
                            <div className="grid">
                                <div className="col-12">
                                    <Card header={header}>
                                        <form  className="error_msg">
                                            <div className="p-fluid formgrid grid">
                                                <div className='col-12 lg:col-6'>
                                                    <div className="field col-12 fsv-label">
                                                        <label htmlFor="subTaskName" className="col-6">
                                                            Task Name<span className="p-error">*</span>
                                                        </label><span className="w-full">
                                                            <Controller name="subTaskName" control={form.control}
                                                                rules={{ required: "Task Name is required" }}
                                                                render={({ field, fieldState }) => (
                                                                    <InputText id='subTaskName' value={field.value} onChange={(e) => field.onChange(e.target.value)}
                                                                        placeholder="" className={classNames({ "p-invalid": fieldState.error })} />
                                                                )}
                                                            />
                                                            {getFormErrorMessage("subTaskName")}</span>
                                                    </div>
                                                    <div className="field col-12">
                                                        <label htmlFor="assignTo" className="col-6 fsv-label">
                                                            Assign To
                                                        </label><span className="w-full">
                                                            <Controller name="assignTo" control={form.control}
                                                                // rules={{ required: "Assign To is required" }}
                                                                render={({ field, fieldState }) => (
                                                                    <Dropdown filter id='assignTo' value={field.value} onChange={(e) => field.onChange(e.target.value)}
                                                                        options={userList} optionLabel="first_name" optionValue='_id' placeholder={isLoading ? "Loading..." : ""} disabled={isLoading} className={classNames({ "p-invalid": fieldState.error })} />
                                                                )}
                                                            />
                                                            {getFormErrorMessage("assignTo")}
                                                            </span>
                                                    </div>
                                                    <div className="field col-12">
                                                        <label className="col-6" htmlFor="taskCriticality" >
                                                        Condition for transition<span className="p-error">*</span>
                                                        </label>
                                                        <span className="w-full">
                                                            <Controller
                                                                name="taskCriticality"
                                                                rules={{ required: "Condition for transition is required" }}
                                                                control={form.control}
                                                                render={({ field, fieldState }) => (
                                                                    <Dropdown options={taskCriticalityOptions} value={field.value} placeholder=""
                                                                        onChange={(e) => { field.onChange(e.target.value); setSelectedTaskCriticality(e.target.value); }} className={classNames({ "p-invalid": fieldState.error })}/>
                                                                )}
                                                            />
                                                            {getFormErrorMessage("taskCriticality")}
                                                        </span>
                                                    </div>
                                                    {(selectedTaskCriticality === "Acceptedwithderogation" || subTaskEdit?._id?.subTaskActionPlan) && (
                                                        <div className="field col-12">
                                                            <label className="col-6" htmlFor="actionPlan" >
                                                                Action Plan<span className="p-error">*</span>
                                                            </label>
                                                            <span className="w-full">
                                                                <Controller
                                                                    name="actionPlan"
                                                                    control={form.control}
                                                                    rules={{ required: "Action Plan is required" }}
                                                                    render={({ field, fieldState }) => (
                                                                        <Dropdown id='actionPlan' value={field.value} onChange={(e) => {field.onChange(e.target.value); setSelectedActionPlan(e.target.value); }}
                                                                            options={actionPlan} placeholder="" className={classNames({ "p-invalid": fieldState.error })} />
                                                                    )}
                                                                />
                                                                {getFormErrorMessage("actionPlan")}
                                                            </span>
                                                        </div>
                                                    )}
                                                    <div className="field col-12">
                                                        <label className="col-6 fsv-label">File Attachment<span className="p-error">*</span></label>
                                                        <span className="w-full">
                                                            <Controller name="fileAttachment" control={form.control}
                                                                rules={{ required: "File Attachment is required" }}
                                                                render={({ field, fieldState }) => (
                                                                    <div className="flex flex-wrap gap-2">
                                                                        <div className="flex align-items-center">
                                                                            <RadioButton inputId="fullday" name="fileAttachment" value="Yes" onChange={(e) => field.onChange(e.value)} checked={field.value === 'Yes'} />
                                                                            <label htmlFor="fullday" className="ml-2">Yes</label>
                                                                        </div>
                                                                        <div className="flex align-items-center">
                                                                            <RadioButton inputId="halfday" name="fileAttachment" value="No" onChange={(e) => field.onChange(e.value)} checked={field.value === 'No'} />
                                                                            <label htmlFor="halfday" className="ml-2">No</label>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            />
                                                            {getFormErrorMessage("fileAttachment")}</span>
                                                    </div>
                                                </div>
                                                <div className='col-12 lg:col-6'>
                                                    <div className="field col-12 align-items-start">
                                                        <label htmlFor="subTaskDescription" className="col-6 mt-3 fsv-label">
                                                            Task Description<span className="p-error">*</span>
                                                        </label><span className="w-full">
                                                            <Controller name="subTaskDescription" control={form.control}
                                                                rules={{ required: "Description is required" }}
                                                                render={({ field, fieldState }) => (
                                                                    <InputTextarea rows={5} id='subTaskDescription' value={field.value} onChange={(e) => field.onChange(e.target.value)}
                                                                        placeholder="" className={classNames({ "p-invalid": fieldState.error })} />
                                                                )}
                                                            />
                                                            {getFormErrorMessage("subTaskDescription")}</span>
                                                    </div>
                                                    <div className="field col-12">
                                                        <label htmlFor="subTaskDepartment" className="col-6 fsv-label">
                                                           Department<span className="p-error">*</span>
                                                        </label><span className="w-full">
                                                            <Controller name="subTaskDepartment" control={form.control}
                                                                rules={{ required: "Department is required" }}
                                                                render={({ field, fieldState }) => (
                                                                    <Dropdown filter id='subTaskDepartment' value={field.value} onChange={(e) => field.onChange(e.target.value)}
                                                                        options={departmentList} placeholder={isLoading ? "Loading..." : ""} disabled={isLoading} className={classNames({ "p-invalid": fieldState.error })} />
                                                                )}
                                                            />
                                                            {getFormErrorMessage("subTaskDepartment")}
                                                            </span>
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                            {/* <div> {renderButtonGroup()}</div> */}
                                            <div className="flex justify-content-end">
                                                {renderButtonGroup()}
                                                {renderUpdateSave()}
                                            </div>
                                        </form>
                                    </Card>
                                </div>
                            </div>
                            
                            <div className="title1 cursor-pointer mt-4" onClick={() => { setViewScreen(false); setTaskScreen(false); setTaskView(false) }}>
                                <span className="PS-title pt-2">Sub Task List</span>
                            </div>
                            {isLoading ? 
                          <ProgressBar mode="indeterminate" style={{ height: '2px' }} className='my-3'></ProgressBar> : 
                          <hr className='hr-line'></hr>}
                    <div className="mt-4">
                                <DataTable tableStyle={{ minWidth: '50rem' }} value={subTaskList}>
                                    <Column field="subTaskName" header="Title" className='user-project-header' bodyClassName="user-project-bodyColumn"></Column>
                                    <Column field={(rowData) => rowData?._id?.assignTo?.first_name} header="Assigned to" className='user-project-header' bodyClassName="user-project-bodyColumn"></Column>
                                    <Column field="fileAttachment" body={(rowData) => rowData?._id?.fileAttachment === true ? "Yes" : "No"} header="File Attachements" className='user-project-header' bodyClassName="user-project-bodyColumn"></Column>
                                    <Column field={(rowData) => rowData?._id?.subTaskCriticality === "Acceptedwithderogation"  ? "With derogation"  : rowData?._id?.subTaskCriticality === "Accepted"  ? "Yes" : rowData?._id?.subTaskCriticality === "Rejected" ? "No" : ""} header="Condition for transition" className='user-project-header' bodyClassName="user-project-bodyColumn"></Column>
                                    <Column field="" header="" body={(rowData) => (customSubTaskButtonTemplate(rowData))}></Column>
                                </DataTable>
                    </div>
                        </div>
                        : null
            }
        </div>
    )
}
export default ProjectsDefinition
